module.exports = __webpack_public_path__ + "header-logo.png?db18ab76d31d9733bf52d1d739e097cd";